import { apiService } from './api';
import { Trainer } from '../types';

export interface TrainersFilters {
  search?: string;
  is_active?: boolean;
  is_admin?: boolean;
  skip?: number;
  limit?: number;
}

export interface TrainerStats {
  trainer_id: number;
  trainer_name: string;
  email: string;
  is_active: boolean;
  is_admin: boolean;
  created_at: string;
  stats: {
    active_clients_count: number;
    exercises_count: number;
    workouts_count: number;
    action_logs_count: number;
  };
  recent_actions: Array<{
    action_type: string;
    resource_type: string;
    description: string;
    created_at: string;
  }>;
}

export interface ToggleAdminResponse {
  message: string;
  trainer_id: number;
  is_admin: boolean;
}

export interface ToggleActiveResponse {
  message: string;
  trainer_id: number;
  is_active: boolean;
}

export interface DeleteTrainerResponse {
  message: string;
  trainer_id: number;
}

export interface ChangePasswordResponse {
  message: string;
}

class AdminService {
  // Получение списка всех тренеров
  async getTrainers(filters: TrainersFilters = {}): Promise<Trainer[]> {
    return apiService.getAdminTrainers(filters);
  }

  // Получение информации о конкретном тренере
  async getTrainer(trainerId: number): Promise<Trainer> {
    return apiService.getAdminTrainer(trainerId);
  }

  // Переключение статуса администратора
  async toggleAdminStatus(trainerId: number): Promise<ToggleAdminResponse> {
    return apiService.toggleAdminStatus(trainerId);
  }

  // Переключение статуса активности
  async toggleActiveStatus(trainerId: number): Promise<ToggleActiveResponse> {
    return apiService.toggleActiveStatus(trainerId);
  }

  // Удаление тренера
  async deleteTrainer(trainerId: number): Promise<DeleteTrainerResponse> {
    return apiService.deleteTrainer(trainerId);
  }

  // Получение статистики тренера
  async getTrainerStats(trainerId: number): Promise<TrainerStats> {
    return apiService.getTrainerStats(trainerId);
  }

  // Изменение пароля тренера
  async changeTrainerPassword(trainerId: number, newPassword: string): Promise<ChangePasswordResponse> {
    return apiService.changeTrainerPassword(trainerId, newPassword);
  }
}

export const adminService = new AdminService(); 